import intl from 'react-intl-universal';
import { SearchableUserPickerBulkAction } from '@getsynapse/design-system';
import { useBulkAssign } from '../../hooks/useBulkAssign/useBulkAssign';

const BulkAssign = () => {
  const {
    availableAssignees,
    handleSearchChange,
    handleUpdateSelectedTaskAssignees,
    handleExpandedChange,
    isFetchingAvailableAssignees,
    isDisabled,
    isBulkAssignLoading,
    canFetchMoreAvailableAssignees,
    loadMoreAvailableAssignees,
  } = useBulkAssign();

  return (
    <SearchableUserPickerBulkAction
      users={availableAssignees}
      onExpandedChange={handleExpandedChange}
      onSearchChange={handleSearchChange}
      onSaveCallback={({ selectedUsers, unselectedUsers }) =>
        handleUpdateSelectedTaskAssignees(selectedUsers, unselectedUsers)
      }
      disabled={isDisabled || isBulkAssignLoading}
      isLoading={isFetchingAvailableAssignees}
      isLoadingMessage={intl.get('TASKS.BULK_ASSIGN.LOADING_MESSAGE')}
      loadingMoreMessage={intl.get('TASKS.BULK_ASSIGN.LOAD_MORE_MESSAGE')}
      enableLazyLoading={canFetchMoreAvailableAssignees}
      loadMoreCallback={loadMoreAvailableAssignees}
      loadingMoreErrorMessage={intl.get(
        'TASKS.BULK_ASSIGN.FAILED_LOAD_MORE_MESSAGE'
      )}
      emptyUsersListText={intl.get('TASKS.BULK_ASSIGN.EMPTY_LIST_MESSAGE')}
      actionButtonProps={{
        loading: isBulkAssignLoading,
        tooltipText: isDisabled
          ? intl.get('TASKS.BULK_ACTIONS.EDITABLE_TASKS_COUNT_TOOLTIP')
          : undefined,
      }}
    />
  );
};

export default BulkAssign;
